module.exports = __webpack_public_path__ + "static/IMG_20180907_180106_038-9dd1238d744c90fc23a9d1f715b933bb.webp";